import React from "react";
import "../css/WorkspaceTabs.css";

/**
 * Year selector for defect datasets; uses shared workspace toolbar styles.
 */
function WorkspaceYearSelect({
    id,
    selectedYear,
    onYearChange,
    availableYears = [],
    size = null,
    disabled = false,
}) {
    return (
        <div className="workspace-year-field">
            <label htmlFor={id} className="workspace-year-label">
                Year
            </label>
            <select
                id={id}
                className={`workspace-year-select ${size ? size : ""}`}
                value={selectedYear ?? ""}
                onChange={(e) => onYearChange(e.target.value)}
                disabled={disabled}
            >
                {availableYears.map((year) => (
                    <option key={year} value={year}>
                        {year}
                    </option>
                ))}
            </select>
        </div>
    );
}

export default WorkspaceYearSelect;
